import { RegulationLink } from 'src/components/regulations';

const TermsOfUse = () => (
  <RegulationLink linkKey="TERMS_OF_USES_URL" labelKey="TERMS_OF_USES" />
);

export default TermsOfUse;
